<template>
  <div>
    <div class="type">
      <span>【{{title}}】</span>
    </div>
    <div class="exam-body" :class="{'last-type': isLastType}">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    isLastType: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.type {
    background: $info;
    padding: 10px;
    color: #fff;
    font-size: $font-size-lg;
  }
.exam-body {
  padding: 0 20px 20px;
  box-sizing: border-box;
  border: 1px solid $border-color;
  border-bottom: none;
}
</style>
